import {
  CardChargeStatus,
  CreditCardType
} from '@anm/api/modules/subscription';
import Tooltip from '@anm/components/Tooltip';
import formatSubscriptionDate from '@anm/helpers/subscription/formatSubscriptionDate';
import { useCallback, FC } from 'react';

import {
  Amount,
  DateView,
  InvoiceLinkWrapper,
  PaymentFailedMessage,
  SubscriptionHistoryCardDetails,
  SubscriptionHistoryItemRow
} from './Wrapper';

export type SubscriptionHistoryItemProps = {
  id: string;
  date: string;
  last4: string;
  amount: string;
  status: CardChargeStatus;
  apiDomain: string;
  cardType: CreditCardType;
};

const Error: FC = ({ children }) => {
  const renderErrorMessage = useCallback(() => <>{children}</>, [children]);

  return (
    <Tooltip renderContent={renderErrorMessage}>
      <PaymentFailedMessage>Payment failed</PaymentFailedMessage>
    </Tooltip>
  );
};

const SubscriptionHistoryItem: FC<SubscriptionHistoryItemProps> = ({
  id,
  date,
  last4,
  amount,
  status,
  cardType,
  apiDomain
}) => {
  const isSuccess = status === 'SUCCESS';
  const isRefund = status === 'REFUNDED';
  const isError = !isSuccess && !isRefund;
  const errorMessage = isError && status;
  const invoiceLink = `${apiDomain}subscription/invoice/${id}`;

  return (
    <SubscriptionHistoryItemRow isActive={!isError}>
      <DateView>
        {formatSubscriptionDate(date, {
          monthFormat: 'MMMM',
          isHours: false
        })}
      </DateView>
      <SubscriptionHistoryCardDetails cardType={cardType} last4={last4} />
      <Amount>${amount}</Amount>
      <InvoiceLinkWrapper>
        {!isError && (
          <a href={invoiceLink} target="_blank">
            {isSuccess && <>Download PDF</>}
            {isRefund && <>Refunded</>}
          </a>
        )}

        {isError && <Error>{errorMessage}</Error>}
      </InvoiceLinkWrapper>
    </SubscriptionHistoryItemRow>
  );
};
export default SubscriptionHistoryItem;
